// extracted by mini-css-extract-plugin
module.exports = {"inputText":"InputText_inputText__3m68J","textStandard":"InputText_textStandard__2QDQ2","textMaterial":"InputText_textMaterial__2q35j","hasValue":"InputText_hasValue__imgeh"};